/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeheaderpublished2Inputs */

const en_placeheaderpublished2 = /** @type {(inputs: Placeheaderpublished2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published`)
};

const de_placeheaderpublished2 = /** @type {(inputs: Placeheaderpublished2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlicht`)
};

/**
* | output |
* | --- |
* | "Published" |
*
* @param {Placeheaderpublished2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeheaderpublished2 = /** @type {((inputs?: Placeheaderpublished2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeheaderpublished2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeheaderpublished2(inputs)
	return de_placeheaderpublished2(inputs)
});
export { placeheaderpublished2 as "placeHeaderPublished" }